import React from 'react'

export const DATE_FORMAT = () => "yyyy-MM-dd"
